import {travianFeatures} from "../../../travianCore";
import React, {Fragment} from 'react';

export function TravianVersion({ version, children }) {
    if(travianFeatures.baseVersion === version) {
        return (
            <Fragment>
                {children}
            </Fragment>
        );
    }
    else {
        return null;
    }
}

export const Legends = ({ children }) => <TravianVersion version={4}>{children}</TravianVersion>;
export const Kingdoms = ({ children }) => <TravianVersion version={5}>{children}</TravianVersion>;

export default function BasedOnVersion({ legends, kingdoms }) {
    return (
        <Fragment>
            <Legends>{legends}</Legends>
            <Kingdoms>{kingdoms}</Kingdoms>
        </Fragment>
    );
}
